
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import listado_etiquetas from '@view/a-pedidos-ml/pc/lista/listados/listado-etiquetas.vue';
    import facturacion from '@view/a-pedidos-ml/pc/facturacion/facturacion.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado_etiquetas,
            facturacion
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;


        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => this.Abierto = true );
            
        }

        public AbrirEtiquetas: boolean = false;
        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
            {
                this.Seleccionada = null;
                this.Pedidos.clear();
                this.Evaluando = false;
                this.Iniciar();
            } else
            {

            }
        }


        public AbiertoFacturar: boolean  =false;


        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Evaluando: boolean = false;
        public Seleccionada: number = 0;
        public Pedidos: Pedido[] = [];

        @Watch( 'Seleccionada' )
        async onSeleccionada()
        {
            if ( this.Seleccionada > 0 )
            {
                this.Evaluando = true;
                this.Pedidos.clear();
                await Wait( 1000 );
                let e = await Pedido.HojaDePisoPedidos( this.Seleccionada );

                if ( e.hasRows() )
                {
                    this.Pedidos = e;
                } else
                {
                    Utiles.Notificaciones.Error( 'No hay pedidos pendientes en esta hoja de piso' );
                }
                this.Evaluando = false;
            }
        }
        public HojasDePiso: { id: number; descripcion?: string;  }[] = [];
        async Iniciar()
        {
            this.HojasDePiso.clear();
            let e = await Pedido.HojaDePisoUltimas();
            if ( e.hasRows() )
            {
                e.forEach( x => x.descripcion = 'Hoja de piso Nº ' +x.id );
                this.HojasDePiso.push( ...e );
            }

        }

        public get Ok(): boolean
        {
            return this.Seleccionada > 0 && this.Pedidos.hasRows();
        }

        public Cargando: boolean = false;
        public async Ejecutar()
        {
            if ( this.Pedidos.hasRows() )
            {
                this.AbrirEtiquetas = !this.AbrirEtiquetas;
                //this.$nextTick( () => this.AbiertoFacturar = !this.AbiertoFacturar );

            } else
            {
                Utiles.Notificaciones.Alerta( '¡No hay pedidos pendientes!' );
            }
        }

        async Actualizar()
        {
            this.Abierto = true;
            this.Controlador.Buscador.Buscar();
            await this.Controlador.RecargarEstadistica();

        }

        Cerrar()
        {
            this.Abierto = false;
        }

    }
